import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-16 md:py-24 bg-carbon border-b border-gray-900 px-4" data-id="element-182">
      <div className="max-w-3xl mx-auto" data-id="element-183">
        <div className="bg-gray-900/40 border border-gray-800 rounded-lg p-8 md:p-12 text-center relative overflow-hidden" data-id="element-184">
          {/* Decorative background glow */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-32 bg-emerald/5 blur-[100px] pointer-events-none" data-id="element-185"></div>

          <div className="flex justify-center mb-6 relative z-10" data-id="element-186">
            <div className="w-16 h-16 bg-emerald/10 rounded-full flex items-center justify-center border border-emerald/20" data-id="element-187">
              <ShieldCheck className="w-8 h-8 text-emerald" data-id="element-188" />
            </div>
          </div>

          <h2 className="text-3xl md:text-4xl font-bold text-gold mb-6 relative z-10" data-id="element-189">
            Nuestra Garantía
          </h2>

          <p className="text-lg md:text-xl text-gray-300 leading-relaxed relative z-10" data-id="element-190">
            Si en los primeros 90 días no ves un aumento medible en reservas y
            clientes recurrentes,{' '}
            <strong className="text-white" data-id="element-191">
              trabajamos gratis hasta que lo consigas
            </strong>
            . Sin contratos largos. Sin letra pequeña. Resultados o no pagas.
          </p>
        </div>
      </div>
    </section>;
}